import { useEffect, useState } from 'react';

export const useImagesPreloader = (imageUrls: Array<string | undefined>): void => {
  const urlsKey = imageUrls.filter(Boolean).join(',');

  useEffect(() => {
    urlsKey.split(',').forEach((url) => {
      if (url) {
        const img = new Image();
        img.src = url;
      }
    });
  }, [urlsKey]);
};

export const useImagePreloader = (imageUrl: string | undefined): boolean => {
  const [loadedUrl, setLoadedUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!imageUrl) return;

    const img = new Image();
    img.onload = () => setLoadedUrl(imageUrl);
    img.onerror = () => setLoadedUrl(undefined);
    img.src = imageUrl;
  }, [imageUrl]);

  return imageUrl !== undefined && loadedUrl === imageUrl;
};
